<template>
  <div class="blog-page container mt-5 pt-4">
    <h2 class="mb-4 text-primary">Blog & Updates</h2>
    <div class="list-group">
      <a
        v-for="post in posts"
        :key="post.id"
        href="#"
        class="list-group-item list-group-item-action flex-column align-items-start mb-2 shadow-sm"
      >
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{ post.title }}</h5>
          <small>{{ post.date }}</small>
        </div>
        <p class="mb-1">{{ post.excerpt }}</p>
      </a>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const posts = ref([
  { id: 1, title: "Vue 3 Composition API Tips", date: "Nov 9, 2025", excerpt: "Learn how to write cleaner Vue 3 code with Composition API..." },
  { id: 2, title: "JavaScript ES2025 Features", date: "Nov 7, 2025", excerpt: "Explore the new features in the latest JavaScript version..." },
  { id: 3, title: "Top 5 Web Development Tools", date: "Nov 5, 2025", excerpt: "These tools will help you code faster and smarter..." },
]);
</script>
